import { HeaderText } from "@/components/ui";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/Tabs";
import { MedicalRecordsPreferences } from "./components/MedicalRecordsPreferences";

export const AccountSettings = () => {
  return (
    <div className="p-6 h-full overflow-auto pb-12">
      <HeaderText size="xl" className="mb-4">
        Account Settings
      </HeaderText>

      <section className="mt-4">
        <Tabs defaultValue="medical-records">
          <TabsList className="mb-4">
            <TabsTrigger value="medical-records" className="gap-1.5">
              Medical Records Preferences
            </TabsTrigger>
            <TabsTrigger value="general">General Settings</TabsTrigger>
          </TabsList>
          <TabsContent value="medical-records">
            <MedicalRecordsPreferences />
          </TabsContent>
          <TabsContent value="general">
            <div className="text-center text-muted-foreground py-8">
              General settings coming soon...
            </div>
          </TabsContent>
        </Tabs>
      </section>
    </div>
  );
};
